import Markdown from "markdown-to-jsx";
import { useState, useEffect } from "react";

type TypeEffectProps = {
    text: string;
    speed?: number;
    onComplete?: () => void;
    scrollToBottomHandler?: () => void;
};

const TypeEffect = ({ text, speed = 100, onComplete, scrollToBottomHandler }: TypeEffectProps) => {
    const [visibleText, setVisibleText] = useState("");
    const [index, setIndex] = useState(0);

    function scrollToBottomOfParent() {
        // scroll to bottom of page after answering
        if (typeof scrollToBottomHandler === "function") {
            scrollToBottomHandler();
        }
    }

    useEffect(() => {
        if (index < text.length) {
            const timeoutId = setTimeout(() => {
                setVisibleText((visible) => visible + text.charAt(index));
                setIndex((i) => i + 1);
                // call scroll to bottom handler
                scrollToBottomOfParent();
            }, speed);

            return () => clearTimeout(timeoutId);
        } else {
            // Check if the typing is complete and the onComplete callback is provided
            if (index === text.length && typeof onComplete === "function") {
                onComplete();
            }
        }
    }, [index, text, speed, onComplete]);

    return (
        <div className="mdx-container leading-[170%]">
            <Markdown options={{ forceBlock: true }}>{visibleText}</Markdown>
        </div>
    );
};

export default TypeEffect;
